// extracted by mini-css-extract-plugin
export var teaser = "TeaserSlider-module--teaser--ed40a";
export var teaserContainer = "TeaserSlider-module--teaserContainer--06ec0";